module.exports = __webpack_public_path__ + "img/more.cb8b2fbb.gif";